import Ajax from "base/Ajax";
import {svg_include} from "index";
import LabelModal from "./modal/LabelModal";

export default class Labels {

    constructor($element) {
        this.$element = $element;

        this.$filters = this.$element.find('.js-filter');
        this.$labelTableHolder = this.$element.find('.js-label-table-holder');
        this.$labelTable = this.$element.find('.js-label-table');

        this.request = null;
        this.labels = null;

        this.filters = {};

        try {
            this.labels = JSON.parse($(".js-labels-data").text());
        } catch (e) {
            console.warn("Couldn't load data from page", e);
        }

        this.bindEvents();
        this.getLatestFilters();
    }

    bindEvents() {
        let me = this;

        this.$element.on('change', '.js-filter-value', () => {
            this.getLatestFilters();
            this.getLabels(true);
            return false;
        }).on('click', '.js-labels-modal', function () {
            (new LabelModal(me.labels, $(this).parents('tr').index())).show();
            return false;
        });
    }

    getLatestFilters() {
        this.filters = this.$filters.serializeJSON();
    }

    getLabels() {
        this.$labelTableHolder.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('wp/v2', 'labels', this.filters);

        this.request.then((data) => {
            this.request = null;
            this.$labelTableHolder.removeClass('loading');

            let headers = {};
            if ('undefined' !== typeof data.headers) {
                headers = data.headers;
                delete data.headers;
            }

            this.updateResources(data, headers);
        }).catch((e) => {
            this.request = null;
            this.$labelTableHolder.removeClass('loading');
            console.log(e);
        });
    }

    updateResources(data, headers) {
        if ('undefined' !== typeof data && data.length > 0) {
            this.$labelTable.html('');
            this.labels = data;
            data.forEach((label) => {
                this.$labelTable.append(this.buildLabel(label));
            });
        } else {
            this.showNoDownloadsMessage();
        }
    }

    showNoDownloadsMessage() {
        this.$resourcesTable.html(
            eotwJSXFactory('tr', null, [
                eotwJSXFactory('td', {colSpan: 5}, [
                    eotwJSXFactory('div', {className: "no-results"}, [
                        eotwJSXFactory('div', {className: "no-results__icon", unsafeHtml: (svg_include('circle-icon--no-results'))}),
                        eotwJSXFactory('h2', {className: "heading heading--3"}, ["No Results"]),
                        eotwJSXFactory('p', null, ["There are no labels that match your current filters."])
                    ])
                ])
            ])
        );
    }

    buildLabel(label) {

        let second_unit = label['height-or-length'] === true ? 'H' : 'L';
        let measurements = label.width + label.width_unit + ' W x ' + label.Height + label.height_unit + ' ' + second_unit;
        let diameter = label.diameter + label.diameter_unit + ' ' + label.diameter_location;

        return (
            eotwJSXFactory('tr', null, [
                eotwJSXFactory('td', {unsafeHtml: label.title.rendered}),
                eotwJSXFactory('td', null, [
                    eotwJSXFactory('div', {class: (label.compatibility.indexOf('m') !== -1 ? 'tick' : 'cross')})
                ]),
                eotwJSXFactory('td', null, [
                    eotwJSXFactory('div', {class: (label.compatibility.indexOf('xs') !== -1 ? 'tick' : 'cross')})
                ]),
                eotwJSXFactory('td', null, [
                    eotwJSXFactory('div', {class: (label.compatibility.indexOf('xtra') !== -1 ? 'tick' : 'cross')})
                ]),
                eotwJSXFactory('td', {unsafeHtml: (label.type !== null && label.type !== '') ? label.type : 'N/A'}),
                eotwJSXFactory('td', null, [measurements]),
                eotwJSXFactory('td', null, [diameter]),
                eotwJSXFactory('td', null, [(label.rolls_per_box !== null && label.rolls_per_box !== '') ? label.rolls_per_box : 'N/A']),
                eotwJSXFactory('td', null, [(label.lables_per_roll !== null && label.lables_per_roll !== '') ? label.lables_per_roll : 'N/A']),
                eotwJSXFactory('td', null, [eotwJSXFactory('a', {href: "#NEEDS-LINK", className: "eye-button js-labels-modal", unsafeHtml: (svg_include('view-icon'))})])
            ])
        )
    }
}